import { Autocomplete, Grid, TextField } from '@mui/material';
import {
  getAvailableBusinessForFund,
  getSharedBusinessDataHubLightReport,
} from 'lib/api/multiverse/fund';
import {
  AvailableBusiness,
  AvailableBusinessResponse,
} from 'lib/api/multiverse/fund/types';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import HeaderWithActions from 'lib/designSystem/HeaderWithActions';
import EnhancedTable from 'lib/designSystem/Table';
import { errorHandler } from 'lib/functions/errors';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

const TemporaryBusinesses: React.FC = () => {
  const dispatch = useDispatch();
  const { data, isPending } = getAvailableBusinessForFund(dispatch);
  const [filteredBusinesses, setFilteredBusinesses] =
    useState<AvailableBusinessResponse>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (data) setFilteredBusinesses(data);
  }, [data]);

  const exportLightReport = async (id: number) => {
    try {
      setLoading(true);
      const business = data?.find((x) => x.id === id);
      if (!business) return;
      const { fileUrl, errors } = await getSharedBusinessDataHubLightReport(
        dispatch,
        business.businessIdentifier,
        business.companyId,
      );
      if (errors.length > 0) {
        alert(
          `Ha ocurrido un error: ${errors.map((x: string) => x).join(', \n')}`,
        );
      }
      window.open(fileUrl, '_blank');
    } catch (error) {
      errorHandler(dispatch, error);
    } finally {
      setLoading(false);
    }
  };

  const canExportLightReport = (id: number) => {
    const business = data?.find((x) => x.id === id);
    if (!business) return false;

    if (business.active) return true;
    return false;
  };

  const actions = [
    {
      action: exportLightReport,
      actionLabel: 'Exportar Reporte',
      canShow: canExportLightReport,
    },
  ];

  const handleChange = (event: unknown, newValue: AvailableBusiness | null) => {
    if (!newValue) return setFilteredBusinesses(data || []);
    const filtered = data?.filter((x) => x.id === newValue.id) || [];
    setFilteredBusinesses(filtered);
  };

  const AutoCompleteFilter = () => (
    <Autocomplete
      options={data || []}
      getOptionLabel={(option) =>
        `${option.businessName} - ${option.businessIdentifier}`
      }
      renderInput={(params) => (
        <TextField style={{ minWidth: 250 }} {...params} label="Filtrar" />
      )}
      onChange={handleChange}
      fullWidth
    />
  );

  if (isPending || loading) return <CenteredCircularProgress />;

  return (
    <div>
      <HeaderWithActions
        type="subHeader"
        title="Estas son las cuentas que te han compartido. Tus clientes pueden desactivarlas cuando lo requieran."
        variant="body1"
        item={
          <Grid container>
            <Grid item xs={12}>
              <AutoCompleteFilter />
            </Grid>
          </Grid>
        }
      />
      <EnhancedTable
        dataHeaders={[
          { key: 'businessName', label: 'Cliente' },
          { key: 'businessIdentifier', label: 'Rut' },
          { key: 'active', label: 'SII', type: 'sii-connection-temporary' },
          { key: 'companyName', label: 'Compartido por' },
          { key: 'expiresAt', label: 'Compartido hasta', type: 'date' },
        ]}
        data={filteredBusinesses}
        rowsPerPageDefault={25}
        showActions
        actions={actions}
      />
    </div>
  );
};

export default TemporaryBusinesses;
